module.exports = __webpack_public_path__ + "img/微信公众号.ced85646.png";